<template>
  <div class="price-scheme-pos">
    <table class="price-table">
      <thead>
      <tr>
        <th>REVENUE CENTER</th>
        <th>MODE</th>
        <th>PRICE</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="rcm of revenueCenterToMode" :key="`it_${value.id}_ps_${rcm.tag}`">
        <td>{{$to(rcm.center.name)}}</td>
        <td>{{$to(rcm.mode.name)}}</td>
        <td>
          <input v-if="!!valueAsMap[rcm.tag]" v-model.number="valueAsMap[rcm.tag].unitPrice" type="number" >
          <input v-else type="number" disabled>
        </td>
        <td>
          <input :id="`it_${value.id}_ps_${rcm.tag}_chk`" type="checkbox" :checked="!!valueAsMap[rcm.tag]" @click="toggle(rcm.tag)">
          <label :for="`it_${value.id}_ps_${rcm.tag}_chk`"></label>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "PriceSchemesQSR",
  props: {
    value: Array,
    revenueCenterToMode: Array, /* [{mode: {id, name}, center: {id, name}, tag: string}]*/
  },

  data() {
    return {
      deleteCache: {} /* When deleting by mistake */
    }
  },

  computed: {
    valueAsMap() {
      /* MapOf<Method|Tag, PriceScheme> */
      return Object.fromEntries( this.value.map(e => [e.method, e]) );
    }
  },

  methods: {
    toggle(tag) {
      this.valueAsMap[tag]
        ? this.removeScheme(tag)
        : this.addScheme(tag);
    },
    addScheme(tag) {
      let index = this.findSchemeIndex(tag);
      if (index !== -1) { return; }

      this.deleteCache[tag]
        ? this.value.push(this.deleteCache[tag])
        : this.value.push({ method: tag, unitPrice: 0 });
    },
    removeScheme(tag) {
      let index = this.findSchemeIndex(tag);
      if (index === -1) { return; }

      this.deleteCache[tag] = this.value[index];
      this.value.splice(index, 1);
    },
    findSchemeIndex(tag) {
      return this.value.findIndex(e => e.method === tag);
    },
  }
}
</script>

<style lang="scss" scoped>
.price-table {
  tr {
    height: 45px;
  }
  td {
    text-align: center;
    vertical-align: middle;
  }
  th:not(:last-child) {
    width: 120px;
  }
  input {
    width: 100%;
  }
}
</style>